import { PageDecorLayer } from "@/components/decorative/PageDecorLayer";
import { cn } from "@/lib/utils";

interface SitePageShellProps {
  children: React.ReactNode;
  className?: string;
  decor?: "hero" | "none";
}

export function SitePageShell({
  children,
  className,
  decor = "none",
}: SitePageShellProps) {
  return (
    <div className={cn("site-page relative overflow-x-clip", className)}>
      {decor === "hero" ? (
        <PageDecorLayer variant="hero" palette="site" className="fixed inset-0 -z-10" />
      ) : null}
      {children}
    </div>
  );
}
